/**
 * sessionStorage key for the persisted onboarding state.
 *
 * v2: Steps 1 & 2 became multi-select, so `outcomes`/`digitalSetups` are now
 * arrays. The bumped key drops any persisted v1 state with the old singular
 * string shape rather than risk hydrating it into the new array fields.
 */
export const ONBOARDING_STORAGE_KEY = 'jaaq-onboarding-v2';
